<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

/**
 * Rich text block. HTML is sanitized server-side (HTMLPurifier) at save
 * time, so it is safe to SSR with v-html here.
 */
defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <div
    class="site-prose leading-relaxed [&_a]:underline [&_h2]:site-display [&_h3]:site-display [&_p]:my-3 [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_blockquote]:border-l-2 [&_blockquote]:border-[var(--site-accent)] [&_blockquote]:pl-4 [&_blockquote]:italic"
    v-html="data.html || ''"
  />
</template>
